import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { CerAuthorizeService } from 'src/cer-identity/cer-authorize.service';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html'
})
export class SendEmailComponent implements OnInit {
  emailForm: FormGroup = new FormGroup({});
  submitted = false;
  mode: string | undefined;
  errorMessages: string[] = [];

  constructor(private authService: CerAuthorizeService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    var user = this.authService.user$.getValue();
    if (user) {
      this.router.navigateByUrl('/');
    } else {
      const mode = this.activatedRoute.snapshot.paramMap.get('mode');
      if (mode) {
        this.mode = mode;
        this.initializeForm();
      }
    }
  }

  private initializeForm() {
    this.emailForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$')]],
    })
  }

  protected sendEmail() {
    this.submitted = true;
    this.errorMessages = [];

    if (this.emailForm.valid && this.mode) {
      if (this.mode.includes('resend-email-confirmation-link')) {
        this.authService.resendEmailConfirmationLink(this.emailForm.get('email')?.value).subscribe({
          next: (response: any) => {
            this.authService.showNotification(true, response.value.title, response.value.message);
            this.router.navigateByUrl('/account/login');
          }, error: error => {
            if (error.error.errors) {
              this.errorMessages = error.error.errors;
            } else {
              this.errorMessages.push(error.error);
            }
          }
        })
      } else if (this.mode.includes('forgot-username-or-password')) {
        this.authService.forgotUsernameOrPassword(this.emailForm.get('email')?.value).subscribe({
          next: (response: any) => {
            this.authService.showNotification(true, response.value.title, response.value.message);
            this.router.navigateByUrl('/account/login');
          }, error: error => {
            if (error.error.errors) {
              this.errorMessages = error.error.errors;
            } else {
              this.errorMessages.push(error.error);
            }
          }
        })
      }
    }
  }

  protected cancel() {
    this.router.navigateByUrl('/account/login');
  }
}
